// -----------------------------------------------------------------------------
//
// This file is the copyrighted property of Tableau Software and is protected
// by registered patents and other applicable U.S. and international laws and
// regulations.
//
// Unlicensed use of the contents of this file is prohibited. Please refer to
// the NOTICES.txt file for further details.
//
// -----------------------------------------------------------------------------
import { L10n } from '../../ts/L10n/L10n';
import { IExtractTaskInfo } from '../../ts/models/IExtractTaskInfo';
import { Set } from '../../ts/models/Set';
import { ExtractTasks } from '../../extract/resources/ExtractTasks';
import { ContentActionNotification, INotificationTranslationIds } from '../../ts/services/ContentActionNotification';
import { ServiceLocator } from '../../app/ServiceLocator';
import { Messages } from '../../codegen/Localize';
import { Formatters} from '../../codegen/Localize';
import { openReactConfirmationDialog } from '../../commonInfra/dialogs/ReactConfirmationDialog';
import { IResult } from '../../ts/ServerApi/types/IResponse';
import { TabDialogWidth } from '../../commonInfra/dialogs/style/TabDialogWidth';

function execute(extractTasks: Set<IExtractTaskInfo>):  Promise<IResult> {
    let description: string;
    const extractTaskCount = extractTasks.size();
    if (extractTaskCount === 1) {
      const extractTask = extractTasks.first();
      if (extractTask.workbook) {
        description = Messages.extractTaskForResumePausedWorkbookPrompt({
          WORKBOOK_NAME: L10n.elideIfLong(extractTask.workbook.name)
        });
      } else {
        description = Messages.extractTaskForResumePrompt({ITEM_COUNT_LOC: Formatters.formatCount(extractTaskCount)});
      }
    } else {
      description = Messages.extractTaskForResumePrompt({ITEM_COUNT_LOC: Formatters.formatCount(extractTaskCount)});
    }

    const dialogConfig = openReactConfirmationDialog<void,IResult>(
    {
      title: Messages.resumeNow(),
      actionName: Messages.resumeNowConfirmButton(),
      action: () => ExtractTasks.resume(extractTasks.keys()),
      message: description,
      paramsForAction: undefined,
      dialogWidth: TabDialogWidth.width375px,
    });

      dialogConfig.result.then((result: IResult) => {
      const contentActionNotification = ServiceLocator.get<ContentActionNotification>('ContentActionNotification');
      contentActionNotification .notifyResult(extractTasks,result.errors,notificationTranslationIds());
    });

    return Promise.resolve(dialogConfig.result);
  }

function notificationTranslationIds(): INotificationTranslationIds {
    return {
      successId: 'extractTasksResumeSuccess',
      errorId: 'extractTasksResumeError'
    };
  }

export const ResumeExtractTasksAction = {
    execute
  };

export type ResumeExtractTasksAction = typeof ResumeExtractTasksAction;



